// Returns the run slug from /ai-3d-model-generator/3d-models/<slug>, or null for other paths.
const SHARED_RUN_SLUG_REGEX = /^\/ai-3d-model-generator\/3d-models\/([^/]+)\/?$/

export const parseRunSlugFromPathname = (pathname) => {
  if (typeof pathname !== 'string') {
    return null
  }
  const match = pathname.match(SHARED_RUN_SLUG_REGEX)
  return match ? match[1] : null
}

export default parseRunSlugFromPathname
